var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('app-primary', {
    scopedSlots: _vm._u([{
      key: "contentsHead",
      fn: function () {
        return [_c('sub-head-primary', {
          attrs: {
            "bg": "/images/sub/story/visual.jpg"
          },
          scopedSlots: _vm._u([{
            key: "title",
            fn: function () {
              return [_vm._v(_vm._s(_vm.$t("고추장 이야기")))];
            },
            proxy: true
          }])
        })];
      },
      proxy: true
    }])
  }, [_c('page-section-primary', {
    staticClass: "page-section--first page-section--last",
    attrs: {
      "titWrapClass": "text-center"
    },
    scopedSlots: _vm._u([{
      key: "subtit",
      fn: function () {
        return [_vm._v("story")];
      },
      proxy: true
    }, {
      key: "tit",
      fn: function () {
        return [_vm._v(_vm._s(_vm.$t("고추장 이야기")))];
      },
      proxy: true
    }])
  }, [_c('div', {
    staticClass: "story"
  }, [_c('v-row', {
    attrs: {
      "no-gutters": "",
      "justify": "end",
      "align": "center"
    }
  }, [_c('v-col', {
    attrs: {
      "cols": "12",
      "md": "6"
    }
  }, [_c('div', {
    staticClass: "story__txt"
  }, [_c('u-tit-wrap-default', {
    staticClass: "tit-wrap--sm"
  }, [_c('u-tit-subtit', [_vm._v("01")]), _c('u-tit-default', [_vm._v(_vm._s(_vm.$t("story1.tit")))])], 1), _c('txt-primary', {
    staticClass: "grey--text text--darken-4"
  }, [_c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.$t('story1.txt'))
    }
  })])], 1)]), _c('v-col', {
    attrs: {
      "cols": "12",
      "md": "6"
    }
  }, [_c('div', {
    staticClass: "story__bg story__bg--01",
    attrs: {
      "data-aos": "fade-left",
      "data-aos-delay": "100",
      "data-aos-offset": "300"
    }
  }, [_c('v-img', {
    staticClass: "d-xl-none",
    attrs: {
      "eager": "",
      "src": "/images/sub/story/story-01.jpg"
    }
  })], 1)])], 1)], 1), _c('div', {
    staticClass: "story"
  }, [_c('v-row', {
    attrs: {
      "no-gutters": "",
      "justify": "end",
      "align": "center"
    }
  }, [_c('v-col', {
    attrs: {
      "cols": "12",
      "md": "6",
      "order-md": "2"
    }
  }, [_c('div', {
    staticClass: "story__txt"
  }, [_c('u-tit-wrap-default', {
    staticClass: "tit-wrap--sm"
  }, [_c('u-tit-subtit', [_vm._v("02")]), _c('u-tit-default', [_vm._v(_vm._s(_vm.$t("story2.tit")))])], 1), _c('txt-primary', {
    staticClass: "grey--text text--darken-4"
  }, [_c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.$t('story2.txt'))
    }
  })])], 1)]), _c('v-col', {
    attrs: {
      "cols": "12",
      "md": "6",
      "order-md": "1"
    }
  }, [_c('div', {
    staticClass: "story__bg story__bg--02",
    attrs: {
      "data-aos": "fade-right",
      "data-aos-delay": "100"
    }
  }, [_c('v-img', {
    staticClass: "d-xl-none",
    attrs: {
      "eager": "",
      "src": "/images/sub/story/story-02.jpg"
    }
  })], 1)])], 1)], 1), _c('div', {
    staticClass: "story"
  }, [_c('v-row', {
    attrs: {
      "no-gutters": "",
      "justify": "end",
      "align": "center"
    }
  }, [_c('v-col', {
    attrs: {
      "cols": "12",
      "md": "6"
    }
  }, [_c('div', {
    staticClass: "story__txt"
  }, [_c('u-tit-wrap-default', {
    staticClass: "tit-wrap--sm"
  }, [_c('u-tit-subtit', [_vm._v("03")]), _c('u-tit-default', [_vm._v(_vm._s(_vm.$t("story3.tit")))])], 1), _c('txt-primary', {
    staticClass: "grey--text text--darken-4"
  }, [_c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.$t('story3.txt'))
    }
  })])], 1)]), _c('v-col', {
    attrs: {
      "cols": "12",
      "md": "6"
    }
  }, [_c('div', {
    staticClass: "story__bg story__bg--03",
    attrs: {
      "data-aos": "fade-left",
      "data-aos-delay": "100"
    }
  }, [_c('v-img', {
    staticClass: "d-xl-none",
    attrs: {
      "eager": "",
      "src": "/images/sub/story/story-03.jpg"
    }
  })], 1)])], 1)], 1), _c('div', {
    staticClass: "story"
  }, [_c('v-row', {
    attrs: {
      "no-gutters": "",
      "justify": "end",
      "align": "center"
    }
  }, [_c('v-col', {
    attrs: {
      "cols": "12",
      "md": "6",
      "order-md": "2"
    }
  }, [_c('div', {
    staticClass: "story__txt"
  }, [_c('u-tit-wrap-default', {
    staticClass: "tit-wrap--sm"
  }, [_c('u-tit-subtit', [_vm._v("04")]), _c('u-tit-default', [_vm._v(_vm._s(_vm.$t("story4.tit")))])], 1), _c('txt-primary', {
    staticClass: "grey--text text--darken-4"
  }, [_c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.$t('story4.txt'))
    }
  })])], 1)]), _c('v-col', {
    attrs: {
      "cols": "12",
      "md": "6",
      "order-md": "1"
    }
  }, [_c('div', {
    staticClass: "story__bg story__bg--04",
    attrs: {
      "data-aos": "fade-right",
      "data-aos-delay": "100"
    }
  }, [_c('v-img', {
    staticClass: "d-xl-none",
    attrs: {
      "eager": "",
      "src": "/images/sub/story/story-04.jpg"
    }
  })], 1)])], 1)], 1)])], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }